/*
* Contact Map
*/

import {MAP_STYLE} from '../modules/locator'
/* global google */

$.fn.ContactMap = function() {
  let self = this;
  self.map = undefined;

  return function() {
    self.map = new google.maps.Map(self.get(0), {
      styles: MAP_STYLE,
      zoom: $.mlmi.mobile.isMobile ? 12 : 12,
      scrollwheel: false,
      center: {
        lat: 46.112740,
        lng: -74.504797,
      },
    });

    new google.maps.Marker({
      position: {
        lat: 46.112740,
        lng: -74.504797,
      },
      icon: {
        url: '/img/elements/contact-marker.svg',
        scaledSize: new google.maps.Size(36, 36),
        scaledOrigin: new google.maps.Point(-22, -44),
      },
      map: self.map,
    })

    return self;
  }();
};
